import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, Input } from 'antd';
import { toggleAddRule } from '../../redux/actions/rule/toggleAddRule';
import { createRule as addRule } from '../../redux/actions/rule/createRule';

class AddRuleModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onAdd(values.statement,
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Add Rule"
                key={"addrule"}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'add-rule-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="add-rule-form"
                    name="basic"
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="statement"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.rule.ruleAddVisible,
    loading: state.rule.loading,
    token: state.auth.token,
    error: state.rule.error,
    message: state.rule.message,
})

const mapDispatchToProps = dispatch => ({
    onAdd: (statement, token) => dispatch(addRule(statement, token)),
    onClose: () => dispatch(toggleAddRule()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddRuleModal);